import { inject, Injectable } from '@angular/core';
import { ViaLyberaNavigation } from '@bilancio/api';
import {
    setIsLyberaStudio,
    viaLyberaLogin,
    viaLyberaLogout
} from '@bilancio/root-store';
import { Store } from '@ngrx/store';
import {
    InterFrameBilMsg,
    InterframeBizHandler,
    InterframeMessageSender,
    logProcessedMsg,
    logUnknownMsg
} from '../interframe-global.model';
import {
    isViaLyberaMessages,
    ViaLyberaMsgRespUnion,
    VlMessage
} from './interframe-via-lybera.model';

@Injectable()
export class InterframeViaLyberaService
    implements InterframeBizHandler, InterframeMessageSender
{
    private readonly store = inject(Store);

    handleMessage(
        msg: InterFrameBilMsg<VlMessage>
    ): ViaLyberaMsgRespUnion | undefined {
        if (!isViaLyberaMessages(msg)) {
            logUnknownMsg('InterframeViaLyberaService', 'blue', msg);
            return undefined;
        }
        switch (msg.Command) {
            case 'interframe-vl-msg-one': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command
                );
                break;
            }
            case 'interframe-vl-msg-two': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command,
                    `id: [${msg.Data.id}]`
                );
                return {
                    Command: 'interframe-vl-msg-two-resp',
                    Data: {
                        status: 'success',
                        receivedId: msg.Data.id
                    }
                };
            }
            case 'interframe-vl-msg-three': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command,
                    `name: ${msg.Data.name}`
                );
                return {
                    Command: 'interframe-vl-msg-three-resp',
                    Data: {
                        status: 'success',
                        receivedName: msg.Data.name
                    }
                };
            }
            case 'interframe-vl-msg-four': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command,
                    `startDate: ${msg.Data.startDate}`
                );
                break;
            }
            case 'interframe-vl-login': {
                let payload: {
                    sessionId: string;
                    tsProcId: string;
                    navigation: ViaLyberaNavigation;
                    tsClientName: string;
                };

                if (typeof msg.Data === 'string') {
                    try {
                        payload = JSON.parse(msg.Data);
                    } catch (error) {
                        console.error('Failed to parse MsgBody JSON:', error);
                        throw new Error('Invalid JSON format in MsgBody');
                    }
                } else {
                    payload = msg.Data;
                }

                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command,
                    `sessionId: ${payload.sessionId}`,
                    `tsProcId: ${payload.tsProcId}`,
                    `navigation: ${payload.navigation}`,
                    `tsClientName: ${payload.tsClientName}`
                );
                this.store.dispatch(
                    viaLyberaLogin({
                        sessionId: payload.sessionId,
                        tsProcId: payload.tsProcId,
                        navigation: payload.navigation,
                        tsClientName: payload.tsClientName
                    })
                );
                this.store.dispatch(
                    setIsLyberaStudio({
                        isLyberaStudio: true
                    })
                );
                break;
            }
            case 'interframe-vl-logout': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'lightblue',
                    msg.Command,
                    'Logout requested from Via Lybera'
                );
                this.store.dispatch(viaLyberaLogout());
                break;
            }
            // Add more cases as needed for other 'vl-msg-*' messages
            default: {
                // Handle unknown 'vl-msg-*' messages if necessary
                console.warn(`Unknown message type: `, msg);
                return undefined;
            }
        }
        return undefined;
    }

    sendToParent(msg: InterFrameBilMsg<VlMessage>): void {
        if (!isViaLyberaMessages(msg)) {
            logUnknownMsg('InterframeViaLyberaService', 'blue', msg);
            return;
        }

        switch (msg.Command) {
            case 'interframe-vl-logout': {
                logProcessedMsg(
                    'InterframeViaLyberaService',
                    'tomato',
                    `Component requesting to send message: ${msg.Command}`,
                    msg
                );
                this.store.dispatch(viaLyberaLogout());
                break;
            }
            // Add more cases for other commands
            default: {
                console.warn(
                    `Unhandled outgoing message type: ${msg.Command}`,
                    msg
                );
            }
        }
    }
}
